import * as moment from 'moment';
import { AnalyticsChartPeriods } from './analytics/analyticsChartPeriods';
import { getWeeksInMonth } from './getWeeksInMonth';
import { getMonthsInYear } from './getMonthsInYear';

interface IGetTimeUnits {
  start: moment.Moment;
  end: moment.Moment;
  
}

export function getTimeUnits(period: AnalyticsChartPeriods, date: number | moment.Moment | Date, dayNames: string[] = []): IGetTimeUnits[] {
  let timeUnits = [];

  if (period === AnalyticsChartPeriods.Daily) {
    timeUnits = getWeeksInMonth(date).map((timeUnit, index) => {
      const days = [0, 1, 2, 3, 4, 5, 6];

      if (index === 0) {
        for (const day of days) {
          dayNames.push(moment(timeUnit.start).add(day, 'days').format('dd'));
        }
      }

      return days.map(d => ({
        start: moment(timeUnit.start).add(d, 'days').startOf('day'),
        end: moment(timeUnit.start).add(d, 'days').endOf('day'),
      }));
    });
  } else if (period === AnalyticsChartPeriods.Weekly) {
    timeUnits = getWeeksInMonth(date);
  } else if (period === AnalyticsChartPeriods.Monthly) {
    timeUnits = getMonthsInYear(date);
  }

  return timeUnits;
}
